const RecetaDigitalIcon = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.45315 3.4531C4.44628 2.45997 7.59694 0.690575 10.3595 3.4531L20.0297 13.1233C21.4102 14.5039 22.469 17.5903 20.0297 20.0296C17.591 22.4682 14.5046 21.4109 13.1234 20.0296L3.45315 10.3594C0.690631 7.59688 2.46003 4.44622 3.45315 3.4531ZM4.83441 4.83436C3.37995 6.28883 4.14378 8.28751 4.83441 8.97814L9.66883 13.8126L13.8126 9.66877L8.9782 4.83436C8.28757 4.14373 6.28957 3.3792 4.83441 4.83436Z"
        fill={ color }
      />
    </svg>
  );
};

export default RecetaDigitalIcon;
